import { Link, useLocation } from 'react-router-dom';
import Seo from '../components/Seo';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex h-screen flex-col items-center justify-center px-6 text-center">
      <Seo
        title="Page not found · F&B Insights"
        description="The page you are looking for does not exist."
      />
      <h1 className="pointer-events-none absolute bottom-0 z-0 select-none text-9xl font-black text-fb-light md:text-[12rem]">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="mt-6 text-xl font-semibold text-fb-navy md:text-2xl">Page not found</h1>
        <p className="mt-2 font-mono text-base text-fb-muted">{location.pathname}</p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-fb-blue px-6 py-3 text-[15px] font-semibold text-white transition-colors hover:bg-fb-navy"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
}
